import { setUser } from '@sentry/browser'
import { createFileRoute, useLoaderData } from '@tanstack/react-router'
import { getCurrentUserApiV1UsersSelfGet } from 'api/endpoints/openapi-generated'
import { UserResponse } from 'api/endpoints/openapi-generated.schemas'
import { ANONYMOUS_USER_TOKEN_LS_KEY } from 'constants/ls'
import { MainPage } from 'features/main'

const loader = async () => {
  const accessToken =
    localStorage.getItem('token') ??
    localStorage.getItem(ANONYMOUS_USER_TOKEN_LS_KEY)
  if (!accessToken) return { userData: undefined }
  try {
    const data = await getCurrentUserApiV1UsersSelfGet()
    setUser({ id: data.data.id, email: data.data.email })
    return { userData: data ?? ({} as UserResponse) }
  } catch (error) {
    return { userData: undefined }
  }
}

export const Route = createFileRoute('/')({
  loader,
  component: () => {
    // eslint-disable-next-line react-hooks/rules-of-hooks
    const { userData } = useLoaderData({ from: '/' })

    return <MainPage userData={userData} />
  }
})
